import { MediaQueries } from 'custom_hooks/useWindowSize';
import {
    PinSize,
    PinTextFontFamily,
    PinTextFontSize,
} from 'shared/svg_annotations/shared/shared';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const ChartDataEditorWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 33rem;
    gap: 2rem;
    overflow: hidden;

    @media ${MediaQueries.mediumAndDown} {
        grid-template-columns: auto;
        grid-template-rows: auto;
    }
`;

export const ChartDataContainer = styled.div`
    display: grid;
    grid-template-rows: max-content auto 1fr;
    grid-template-areas:
        'plot'
        'toolbar'
        'legend';
    row-gap: 1rem;
    overflow: auto;
    position: relative;
`;

export const ChartDataPlotSection = styled.div`
    grid-area: plot;
`;

export const AnnotationsToolbarSection = styled.div`
    grid-area: toolbar;
`;

export const ChartDataLegendSection = styled.div`
    grid-area: legend;
    overflow-y: scroll;
`;

export const PlotDisplayContainer = styled.div`
    display: flex;
    padding-left: 1rem;
    align-items: center;
`;

export const ChartDataPlotSvgContainer = styled.div`
    border: solid 1px ${tokens.border.default};
    position: relative;
    border-radius: 5px;
`;

export const ChartDataAnnotationsContainer = styled.div`
    position: absolute;
    inset: 0;
`;

export const ChartDataToolbar = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
`;

export const ChartDataToolbarGroup = styled.div`
    border: solid 1px ${tokens.border.default};
    padding: 0.5rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.5rem;
    border-radius: 5px;
`;

export const ChartDataSelectedTool = styled.div`
    background: ${tokens.text.link};
    border-radius: 0.25rem;
    color: ${tokens.foreground.inverse};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ToolIcon = styled.div`
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.25rem;
    font-size: 1.6rem;
`;

export type AnnotationPaletteOuterColorProps = Readonly<{
    $color: string;
}>;

export const AnnotationPaletteOuterColor = styled.div<AnnotationPaletteOuterColorProps>`
    border: solid 1.5px ${tokens.border.default};
    border-radius: 100%;
    background: ${({ $color }) => $color};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export type AnnotationPaletteInnerColorProps = Readonly<{
    $color: string;
    $ringColor?: string;
}>;

export const AnnotationPaletteInnerColor = styled.div<AnnotationPaletteInnerColorProps>`
    width: 1.15rem;
    height: 1.15rem;
    background: ${({ $color }) => $color};
    border: solid 1.5px ${({ $color, $ringColor }) => $ringColor ?? $color};
    border-radius: 100%;
    margin: 0.25rem;
`;

export const TextAnnotationEditors = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow-y: scroll;
`;

export const TextEditorSection = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto;
    align-items: start;
    gap: 1rem;
`;

export type AnnotationPinProps = Readonly<{
    $color: string;
    $textColor: string;
}>;

export const AnnotationPin = styled.div<AnnotationPinProps>`
    width: ${PinSize * 2}px;
    height: ${PinSize * 2}px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${PinTextFontSize}px;
    font-family: ${PinTextFontFamily};
    background: ${({ $color }) => $color};
    // DSM styling for Button specifies color for nested
    // divs (usually for spinners), so we need !important here
    color: ${({ $textColor }) => $textColor} !important;
    font-weight: 500;
    border-radius: 100%;
`;

export const PinSelectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 20rem;
    overflow-y: auto;
    gap: 1rem;
    padding: 1rem;
`;
